export const PERSON_SALARY_REPORT_UPDATED = "PERSON_SALARY_REPORT_UPDATED";
export const PERSON_SALARY_REPORT_COMPLETED = "PERSON_SALARY_REPORT_COMPLETED";
